export default __webpack_public_path__ + "0cbf4057b7444b868626a5059e5eafaf.png";